export default __webpack_public_path__ + "static/media/ftj-2.0144dc49.jpeg";